import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseNoteAccountApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const postToHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  data?: unknown,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.post(`${baseNoteAccountApiUrl}${remainingPath}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
